export default {
    welcome: 'Welcome to Vanguard',
    Home: 'Home',
    Markets: 'Markets',
    Trade: 'Trade',
    Futures: 'Futures',
    Finance: 'Finance',
    foot: {
        nav1: 'Home',
        nav2: 'Market',
        nav3: 'Position',
        nav4: 'News',
        nav5: 'User',
    },
    index: {
        text1: 'Total account value',
        text2: 'Noteworthy',
        text3: 'See All',
        text4: 'Deposit',
        text5: 'Withdraw',
        text6: 'Market',
        text7: 'System Notification'
    },
    // lang: {
    // 	login: 'Login'
    // },
    common: {
        enter: 'Please enter ',
        code: 'Get code',
        itc: 'Select Area Code',
        loading: 'Loading...',
        success: 'Success',
        fail: 'Failure',
        cancel: 'Cancel',
        submit: 'Submit',
        confirm: 'Confirm',
        opt: 'Operation',
    },
    reg: {
        text: 'Sign Up',
        email_tip: 'Register with an email account',
        phone_tip: 'Register with mobile phone number',
        email: 'Email',
        phone: 'Mobile phone number',
        password: 'Password',
        repassword: 'Confirm password',
        invite: 'Invitation code',
        code: 'Verification code',
        checkpass: 'Repeated passwords are different',
        checkbox: 'Please agree to the agreement',
        exist: "Don't have an account?"
    },
    login: {
        text: 'Login In',
        exist: 'Existing account?',
        tips: 'Please log in to access your account'
    },
    forget: {
        text: 'Forgot Password',
        tips: "Enter your email or phone number linked to your account. We'll send you an OTP to reset your password"
    },
    kefu: {
        text: 'Online Customer Service'
    },
    coin: {
        user: 'User Center',
        asset: 'Asset',
        spot: 'Spot',
        spot_account: 'Spot Account',
        futures: 'Futures',
        futures_account: 'Futures Account',
        trade: 'Trade',
        trade_account: 'Trade Account',
        stock: 'Stock',
        stock_account: 'Stock Account',
        options: 'Options',
        options_account: 'Options Account',
        crypto: 'Crypto',
        stocks: 'Stocks',
        forex: 'Forex',
        funds: 'ETF',
        indices: 'Indices',
        overview: 'Overview',
        fund: 'Funding',
        fund_account: 'Funding Account',
        deposit: 'Deposit',
        withdraw: 'Withdraw',
        transfer: 'Transfer',
        transfer_record: 'Transfer Record',
        total_asset: 'Total Assets',
        coin: 'Currency',
        usable: 'Usable',
        freeze: 'Freeze',
        lprice: 'Last Price',
        change: 'Change',
        high: '24h High',
        low: '24h Low',
        vol: '24h Vol',
        available: 'Available',
        market: 'Market',
        limit: 'Limit',
        price: 'Price',
        amount: 'Amount',
        trade_amount: 'Traded Amount',
        traded_money: 'Traded Money',
        no_money: 'Insufficient balance',
        minute: 'M',
        hour: 'H',
        day: 'D',
        trade_log: 'Transaction Record',
        buy: 'Buy',
        sell: 'Sell',
        time: 'Time',
        side: 'Direction',
        quantity: 'Quantity',
        cur_order: "Current Order",
        his_order: "Historical Order",
        status: 'Status',
        cancel: 'Cancel',
        empty: 'No data'
    },
    contract: {
        cross: 'Cross',
        buy: 'Buy long',
        sell: 'Sell short',
        used: 'Margin',
        risk: 'Risk Rate',
        unprofit: 'Unreal Profit',
        fee: 'Fee',
        corder: 'Current Orders',
        cpos: 'Current Positions',
        hold_pos: 'Hold Position',
        flat_price: 'Flat Price',
        tp_price: 'Take profit Price',
        sl_price: 'Stop-loss Price',
        rt_price: 'Real-time price',
        profit_num: 'Profit Number',
        profit_rate: 'Profit Rate',
        profit: 'Profit',
        close: 'Close',
        reverse: 'Reverse',
        oprice: 'Positioning price',
        nums: 'Nums',
        max: 'Exceeding the maximum quantity',
        cur_po: 'Outstandings',
        his_po: 'Finished',
        have_po: 'Position',
    },
    cz: {
        text: 'Deposit',
        network: 'Select Network',
        addr: 'Storage address',
        tips: "Only support to recharge this address {account}, please do not recharge other assets.",
        cz_record: 'Recharge Record',
    },
    auth: {
        text: 'Identity Authentication',
        name: 'Name',
        id_card: 'ID card',
        img_1: 'Please upload the front of your ID photo',
        img_2: 'Please upload the reverse side of the ID photo'
    },
    pwd: {
        text: 'Login password',
        text1: 'Transaction password'
    },
    help: {
        text: 'Help Center'
    },
    tx: {
        text: 'Withdraw',
        se_addr: 'Select Address',
        tx_1: 'Cash will arrive within 24 hours of withdrawal',
        tx_2: 'Withdrawal time: Between 9am and 17pm Monday to Friday'
    },
    invite: {
        text: 'Invite',
        yi: 'Level 1',
        er: 'Level 2',
        san: 'Level 3',
        yao: 'My Invitation',
        fan: 'Maximum reward Rebate benefits',
        code: 'Invitation code',
        link: 'Invitation link'
    },
    address: {
        text: 'Address Book',
        address: 'Address',
        remark: 'Remark'
    },
    block: {
        text: 'Block Trade'
    }
}
